import { Injectable } from '@angular/core';
import type {
  FaceLandmarker,
  FaceLandmarkerResult,
} from './face-filter-lazy.module';
import type { FaceFilterThree } from './face-filter.interface';

@Injectable({
  providedIn: 'root',
})
export class FaceFilterService {
  private _faceLandmarker: FaceLandmarker | undefined;

  async initiateFaceLandmarker(): Promise<void> {
    if (!this._faceLandmarker) {
      const { FaceLandmarker, FilesetResolver } = await import(
        './face-filter-lazy.module'
      );

      const filesetResolver = await FilesetResolver.forVisionTasks(
        'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.3/wasm',
      );

      this._faceLandmarker = await FaceLandmarker.createFromOptions(
        filesetResolver,
        {
          baseOptions: {
            modelAssetPath:
              'https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/latest/face_landmarker.task',
            delegate: 'GPU',
          },
          outputFaceBlendshapes: true,
          outputFacialTransformationMatrixes: true,
          runningMode: 'VIDEO',
          numFaces: 1,
        },
      );
    }
  }

  async detectForVideo(
    video: HTMLVideoElement,
  ): Promise<FaceLandmarkerResult | void> {
    return this._faceLandmarker?.detectForVideo(video, Date.now());
  }

  async drawTessellation(
    canvasContext: CanvasRenderingContext2D,
    results: FaceLandmarkerResult,
  ): Promise<void> {
    const { FaceLandmarker, DrawingUtils } = await import(
      './face-filter-lazy.module'
    );
    const drawingUtils = new DrawingUtils(canvasContext);

    if (results.faceLandmarks) {
      for (const landmarks of results.faceLandmarks) {
        drawingUtils.drawConnectors(
          landmarks,
          FaceLandmarker.FACE_LANDMARKS_TESSELATION,
          { color: '#eaf2fd', lineWidth: 1 },
        );
      }
    }
  }

  async loadThree(): Promise<FaceFilterThree | void> {
    return import('./three-lazy.module');
  }
}
